'use client';

import type { RefObject } from 'react';
import { useGsapContext } from 'hooks/animation/useGsapContext';
import { useIsomorphicLayoutEffect } from 'hooks/dom/useIsomorphicLayoutEffect';
import {
  bindOnceTextReveal,
  TEXT_REVEAL_FULL,
} from 'components/landing/v3/scrollBeat';

/* One-time fade-up of a section's [data-reveal] copy, as EmeraldArcSection does
   with [data-emerald-copy]. bindOnceTextReveal no-ops under reduced motion. */
export function useTextReveal(sectionRef: RefObject<HTMLElement | null>) {
  const gsapCtx = useGsapContext(sectionRef);

  useIsomorphicLayoutEffect(() => {
    gsapCtx.add(() => {
      const section = sectionRef.current;
      if (!section) return undefined;
      const items = Array.from(
        section.querySelectorAll<HTMLElement>('[data-reveal]'),
      );
      if (!items.length) return undefined;
      return bindOnceTextReveal(items, {
        ...TEXT_REVEAL_FULL,
        stagger: 0.06,
        trigger: items[0],
      });
    });
  }, [gsapCtx]);
}
